export const resolvePharmacySlugFromRecord = (value, record) => {
	if (record && typeof record === 'object' && record.root_pharmacy) {
		return record.root_pharmacy;
	}

	if (typeof value === 'string') {
		return value;
	}

	return null;
};
